export const MAP_TYPE_TO_STRING: { [key: string]: string } = {
  pricing_empty: "got empty pricing",
  lead: "is a new lead",
  new_lead: "is a new lead",
  lead_workflow_loaded: "loaded lead workflow",
  lead_workflow_modal_loaded: "loaded lead workflow modal",
  lead_workflow_completed: "completed lead workflow",
  pricing_shown: "pricing is shown",
  rate_table_loaded: "loaded rate table",
  workflow_button_clicked: "clicked workflow button",
  progress_twentyFivePercent: "progressed 25%",
  progress_fiftyPercent: "progressed 50%",
  progress_seventyFivePercent: "progressed 75%",
  loan_summary_pdf: "loan summary worksheet created",
  unsubscribed: "unsubscribed",
  dashboard_update: "updated dashboard",
  dashboard_contact: "contacted in the dashboard",
  dashboard_pageview: "viewed dashboard",
  dashboard_first_visit: "visited their dashboard for the first time",
  dashboard_initial_visit: "visited their dashboard for the first time",
  reactivated: "reactivated",
  intro_email_sent: "sent subscription intro email",
  intro_email_opened: "intro email was opened",
  intro_email_clicked: "clicked intro email",
  loan_summary_jpeg: "new subscription created by SMS",
  new_subscription: "created a new subscription",
  sms_followup_sent: "was sent an SMS follow-up",
  dashboard_ai_created: "initialized an AI Advisor session",
  created_from_pending: "converted via dream rate"
}

export enum EXCLUDED_ACTIVITY_TYPES {
  email_bounced = "email_bounced",
  stale_unsubscribed = "stale_unsubscribed",
  unsubscribe_param_passed = "unsubscribe_param_passed",
  unsubscribe_link_clicked = "unsubscribe_link_clicked",
  deleted = "deleted",
  followup_sms_sent = "followup_sms_sent",
  rate_alert_quote_failed = "rate_alert_quote_failed"
}
